import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LocationPickerModal from '../components/LocationPickerModal';
import { getPilotUserAddresses } from '../services/addresses';
import { useV2Session } from '../state/SessionProvider';

/** Deep-link fallback: opens the same picker in a modal, then returns home on close. */
export default function LocationPage() {
  const navigate = useNavigate();
  const { loggedIn, mobile } = useV2Session();
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    if (!loggedIn || !mobile) {
      setAddresses([]);
      return undefined;
    }
    let cancelled = false;
    getPilotUserAddresses(mobile)
      .then((list) => {
        if (!cancelled) setAddresses(list);
      })
      .catch(() => {
        if (!cancelled) setAddresses([]);
      });
    return () => {
      cancelled = true;
    };
  }, [loggedIn, mobile]);

  return (
    <LocationPickerModal
      open
      addresses={addresses}
      onClose={() => navigate('/v2', { replace: true })}
      onResolved={() => navigate('/v2', { replace: true })}
    />
  );
}
